<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import BasePaywallModal from './BasePaywallModal.vue';

defineProps({
  featurePrefix: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const { accountId, isOnChatipsCloud } = useAccount();
const currentUser = useMapGetter('getCurrentUser');

const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');
const i18nKey = computed(() =>
  isOnChatipsCloud.value ? 'PAYWALL' : 'ENTERPRISE_PAYWALL'
);

const openBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="grid place-content-center w-full py-10">
    <BasePaywallModal
      :feature-prefix="featurePrefix"
      :i18n-key="i18nKey"
      :is-on-chatips-cloud="isOnChatipsCloud"
      :is-super-admin="isSuperAdmin"
      @upgrade="openBilling"
    />
  </div>
</template>
